import { Play } from "lucide-react";
import { AdultAvatar, KidAvatar } from "@/components/Avatars";
import { fmtDur, mediaUrl } from "@/lib/connect";

export const PINK = "var(--glow-connect)";

export const Face = ({ p, size = 32 }) => (p.kind === "kid" ? <KidAvatar avatar={p.avatar} size={size} /> : <AdultAvatar name={p.name} picture={p.picture} size={size} />);

export function ConvFace({ c, me }) {
  if (c.kind === "dm") { const o = c.members.find((m) => m.key !== me); return o ? <Face p={o} size={44} /> : null; }
  return <span className="inline-flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-full text-xl" style={{ background: `rgba(${PINK},0.16)` }}>{c.emoji || "💬"}</span>;
}

export function MediaGrid({ media, onOpen, mid }) {
  const n = media.length;
  return (
    <div className={`grid gap-1 overflow-hidden rounded-xl ${n === 1 ? "grid-cols-1" : "grid-cols-2"}`} style={{ maxWidth: 320 }} data-testid={`message-media-${mid}`}>
      {media.map((m, i) => (
        <button key={m.id} onClick={() => onOpen(i)} className="relative block overflow-hidden bg-black/20" style={{ aspectRatio: n === 1 && m.width ? `${m.width}/${m.height}` : "1/1" }} data-testid={`message-media-item-${m.id}`}>
          {m.type === "video" ? (
            <>
              {m.poster ? <img src={mediaUrl(m.poster)} alt="" className="h-full w-full object-cover" loading="lazy" /> : <div className="h-full w-full bg-black" />}
              <span className="absolute inset-0 flex items-center justify-center"><span className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-black/55 text-white"><Play className="h-6 w-6" /></span></span>
              <span className="absolute bottom-1.5 right-1.5 rounded bg-black/65 px-1.5 text-xs font-bold text-white" data-testid={`video-duration-${m.id}`}>{fmtDur(m.duration)}</span>
            </>
          ) : <img src={mediaUrl(m.url)} alt={m.name} className="h-full w-full object-cover" loading="lazy" />}
        </button>
      ))}
    </div>
  );
}
